import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { editFeaturesGroup, 
        deleteCards, 
        editCards, 
        popUpMessageChange, 
        editFigures } from '../../actions/index';

import { Button } from '@material-ui/core';

import { _ } from '../../functions/translator.js';
import { postData } from '../../functions/postData.js';
import { reloadCardsGroupsFeatures } from '../../functions/map/reloadCardsGroups';
import { CardsGroupStatus } from '../../constants/constants';
import { showMessage } from '../../functions/popUpMessage.js';

class ConfirmationMessage extends React.Component{

    handleClose = () => {
        let openCardsGroupIds = this.props.deletedCardsGroups.filter((cardsGroupId) => {
            let cardsGroupData = this.props.projectData.cards_groups[cardsGroupId];
            if (!cardsGroupData) return false;
            let status = cardsGroupData.attributes.status;
            return status === CardsGroupStatus.OPEN;
        })
        if (openCardsGroupIds.length > 0) {
            let protocolText = openCardsGroupIds.length > 1 ? _('protocolos') : _('protocolo');
            const message = `¿${_('Estás seguro de dejar en pendiente')} ${openCardsGroupIds.length} ${protocolText}?`;
            const messageConfig = {
                closeButton: true,
                standByConfirmation: true,
                cardsGroupIds: openCardsGroupIds
            };
            showMessage(this.props, message, messageConfig);
        } else {
            this.props.popUpMessageChange({ show: false });
        }
    }

    handleDelete = async () => {
        const message = _('Eliminando protocolos') + '...';
        showMessage(this.props, message, { loading: true });
        let urlPost = {
            'cards_group_ids': this.props.deletedCardsGroups,
            'project_id': window.project_id
        }
        let response = await postData('/web-api/delete-cards-groups', urlPost)
        this.handleResponse(response)
    }

    handleResponse = (response) => {
        if (response.status === 'success') {
            if (this.props.deletedCardsGroups.length > 1) {
                showMessage(this.props, '¡' + _('Protocolos eliminados exitosamente') + '!');
            } else {
                showMessage(this.props, '¡' + _('Protocolo eliminado exitosamente') + '!');
            }
            this.props.deleteCards(this.props.deletedCardsGroups);
            reloadCardsGroupsFeatures(this.props, [], this.props.deletedCardsGroups);
        } else {
            showMessage(this.props, _('Ocurrió un error al eliminar los protocolos'));
        }
    }

    render(){
        let openCardsGroupIds = this.props.deletedCardsGroups.filter((cardsGroupId) => {
            let cardsGroupData = this.props.projectData.cards_groups[cardsGroupId];
            if (!cardsGroupData) return false;
            let status = cardsGroupData.attributes.status;
            return status === CardsGroupStatus.OPEN;
        })
        let buttonText = openCardsGroupIds.length > 0 ? _('Devolver') : _('Cancelar');
        let buttonClass = openCardsGroupIds.length > 0 ? 'confirm-warning-button' : 'confirm-cancel-button';
        return (
            <div>
                <div className="d-flex justify-content-around mt-4">
                    <Button variant="contained" className='confirm-delete-button' onClick={ this.handleDelete }>
                        <span style={{color:'white'}}>{ _('Eliminar') }</span>
                    </Button>
                    <Button variant="contained" className={ buttonClass } onClick={ this.handleClose }>
                        <span style={{color:'white'}}>{ buttonText }</span>
                    </Button>
                </div>
            </div>
        );

    }
}

function mapStateToProps( state ){
    return {
        projectData : state.projectData,
        deletedCardsGroups : state.deletedCardsGroups
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        editCards : editCards,
        deleteCards : deleteCards,
        editFeaturesGroup : editFeaturesGroup,
        popUpMessageChange : popUpMessageChange,
        editFigures : editFigures
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(ConfirmationMessage)